"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { Bell, BellOff, Trash2 } from "lucide-react";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { EmptyState } from "@/components/ui/empty-state";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useNotifications } from "@/hooks/useNotifications";
import { cn, formatRelativeTime } from "@/lib/utils";
import type { Notification } from "@/queries/notification/fetchers";
import { WorkflowNotificationStatus } from "@/types/workflow";
export function NotificationList() {
  const $ = _c(34);
  const router = useRouter();
  const [isListOpen, setIsListOpen] = useState(false);
  let t0;
  if ($[0] !== isListOpen) {
    t0 = {
      listEnabled: isListOpen
    };
    $[0] = isListOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data,
    fetchNotificationList,
    isLoading,
    unreadCount,
    updateNotification,
    updatingNotification,
    mutationValues
  } = useNotifications(t0);
  let t1;
  if ($[2] !== data?.notifications) {
    t1 = data?.notifications ?? [];
    $[2] = data?.notifications;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const notifications = t1;
  let t2;
  if ($[4] !== fetchNotificationList || $[5] !== updateNotification) {
    t2 = async open => {
      setIsListOpen(open);
      if (!open) {
        return;
      }
      const list = await fetchNotificationList();
      const toMark = (list.notifications ?? []).filter(_temp);
      if (toMark.length === 0) {
        return;
      }
      await updateNotification({
        ids: toMark.map(_temp2),
        status: WorkflowNotificationStatus.VIEWED
      });
    };
    $[4] = fetchNotificationList;
    $[5] = updateNotification;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleOpenChange = t2;
  let t3;
  if ($[7] !== updateNotification) {
    t3 = async (t4, status) => {
      const {
        id,
        workflowId,
        subscriberId
      } = t4;
      await updateNotification({
        ids: [{
          id,
          subscriberId,
          workflowId
        }],
        status
      });
    };
    $[7] = updateNotification;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleStatusUpdate = t3;
  let t4;
  if ($[9] !== router) {
    t4 = async notification_1 => {
      const {
        workflow
      } = notification_1;
      const workspaceId = workflow?.workspaceId;
      const view = workflow?.metadata?.viewName;
      const viewVisualizationId = workflow?.metadata?.viewVisualizationId;
      if (workspaceId && view) {
        return router.push(`/${workspaceId}/${view.toLowerCase()}`);
      }
      if (viewVisualizationId) {
        const visualization = window.document.querySelector(`3${viewVisualizationId}`);
        if (visualization) {
          visualization.scrollIntoView({
            behavior: "smooth"
          });
        }
      }
    };
    $[9] = router;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleNotification = t4;
  const t5 = isLoading || updatingNotification;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Bell />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== unreadCount) {
    t7 = unreadCount > 0 && <Badge className="absolute top-0 right-0 px-1.5 py-0.5 size-3 text-[6px] rounded-full bg-destructive text-destructive-foreground border-none">{unreadCount}</Badge>;
    $[12] = unreadCount;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <TooltipTrigger asChild={true}><DropdownMenuTrigger asChild={true}><Button aria-label="Notifications" className="relative ml-auto -mr-2" disabled={t5} size="icon" variant="ghost">{t6}{t7}</Button></DropdownMenuTrigger></TooltipTrigger>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <TooltipContent><p>Notifications</p></TooltipContent>;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8) {
    t10 = <Tooltip>{t8}{t9}</Tooltip>;
    $[18] = t8;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <DropdownMenuLabel className="text-left border-border/40">Notifications</DropdownMenuLabel>;
    t12 = <DropdownMenuSeparator className="my-0" />;
    $[20] = t11;
    $[21] = t12;
  } else {
    t11 = $[20];
    t12 = $[21];
  }
  let t13;
  if ($[22] !== handleNotification || $[23] !== handleStatusUpdate || $[24] !== mutationValues?.ids || $[25] !== notifications || $[26] !== updatingNotification) {
    t13 = notifications.length === 0 ? <EmptyState description="No notifications to display at this time" icon={BellOff} variant="transparent" /> : notifications.map(n => n.id ? <DropdownMenuItem className={cn("group w-full p-3 rounded-none font-normal transition flex flex-col gap-1 cursor-pointer border-l-2 border-l-transparent hover:border-l-muted not-last-of-type:border-b border-b-border/40", n.status === WorkflowNotificationStatus.SENT && "border-l-chart-4 hover:border-l-chart-4 hover:bg-muted")} disabled={updatingNotification && mutationValues?.ids.some(id_0 => id_0.id === n.id)} key={n.id} onClick={() => handleNotification(n)}><div className="flex items-center justify-between w-full gap-1.5"><div className="flex items-center justify-between gap-2 flex-1">{n.workflow?.name && <p className="font-medium text-sm text-foreground max-w-full line-clamp-1">{n?.metadata?.title as string || n.workflow.name}</p>}<p className="text-xs text-muted-foreground shrink-0">{formatRelativeTime(n.createdAt || n.sentAt)}</p></div><button aria-label="Close notification" className="cursor-pointer focus:outline-none md:opacity-0 md:group-hover:opacity-100 opacity-100 transition-opacity" disabled={updatingNotification && mutationValues?.ids.some(id_1 => id_1.id === n.id)} onClick={e => {
          e.stopPropagation();
          handleStatusUpdate({
            id: n.id,
            subscriberId: n.subscriberId,
            workflowId: n.workflowId
          }, WorkflowNotificationStatus.CLOSED);
        }} type="button"><Trash2 className="size-4 text-destructive" strokeWidth={1.5} /></button></div><div className="text-[13px] text-foreground/80 line-clamp-2 text-left w-full truncate">{n.content}</div></DropdownMenuItem> : null);
    $[22] = handleNotification;
    $[23] = handleStatusUpdate;
    $[24] = mutationValues?.ids;
    $[25] = notifications;
    $[26] = updatingNotification;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13) {
    t14 = <DropdownMenuContent align="end" className="w-full max-w-[calc(100dvw-5dvw)] md:max-w-sm sm:max-h-96 overflow-y-auto p-0 shadow-[0px_3px_29px_-3px_rgba(0,0,0,0.1)] border-none" side="bottom" sideOffset={10}>{t11}{t12}{t13}</DropdownMenuContent>;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== handleOpenChange || $[31] !== t10 || $[32] !== t14) {
    t15 = <TooltipProvider><DropdownMenu onOpenChange={handleOpenChange}>{t10}{t14}</DropdownMenu></TooltipProvider>;
    $[30] = handleOpenChange;
    $[31] = t10;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
}
function _temp2(notification_0) {
  return {
    id: notification_0.id,
    subscriberId: notification_0.subscriberId,
    workflowId: notification_0.workflowId
  };
}
function _temp(notification) {
  return notification.status !== WorkflowNotificationStatus.VIEWED && notification.status !== WorkflowNotificationStatus.READ;
}